import { KlevuTypeOfRequest } from "../../models/index.js";
import { cleanSearchQuery } from "../../utils/index.js";
const defaults = {
    id: "suggestions",
    limit: 5,
};
/**
 * Return suggestion on given search term
 *
 * @category Query
 * @param term search term
 * @param options
 * @returns
 */
export function suggestions(term, options) {
    const params = Object.assign(Object.assign({}, defaults), options);
    const query = Object.assign({ typeOfRequest: KlevuTypeOfRequest.Suggestion, query: cleanSearchQuery(term) }, params);
    return {
        klevuFunctionId: "suggestions",
        suggestions: [query],
    };
}
